import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects'

import {
  GET_CURRENCY_TYPES,
  GET_BANKS,
  GET_BANK_REFERENCES,
  CHECK_FOR_UPDATES,
  CHECK_APP_STATUS,
  FINISH_MAINTENANCE,
  SET_CURRENT_FEATURE,
} from '../constants/ActionsTypes'

import { getCurrencyTypes, getBanks, getBankReferencesApi } from '../api/provisionalReceipts'
import { getAppStatus, finishMaintenanceApi } from '../api/Connectivity'

import {
  getCurrencyTypesSuccess,
  getBanksSuccess,
  getBankReferencesSuccess,
  triggerUpdateNotification,
  checkAppStatusSuccess,
  checkAppStatusError,
  setMaintenanceInfo,
  clearMaintenanceInfo,
  finishMaintenanceSuccess,
  finishMaintenanceError,
  clearAutocompleteClients,
} from '../actions'

function* getCurrencyTypesRequest() {
  try {
    const { data } = yield call(getCurrencyTypes)
    yield put(getCurrencyTypesSuccess(data))
  } catch (error) {}
}

function* getBanksRequest() {
  try {
    const { data } = yield call(getBanks)
    yield put(getBanksSuccess(data))
  } catch (error) {}
}

function* getBankReferencesRequest() {
  try {
    const { data } = yield call(getBankReferencesApi)
    yield put(getBankReferencesSuccess(data))
  } catch (error) {}
}

function* checkForUpdatesSaga() {
  const url = `/static/version.js?t=${Date.now()}`

  try {
    const response = yield call(fetch, url)
    const latestVersion = yield response.text()
    const storedVersion = localStorage.getItem('appVersion')

    if (!storedVersion) {
      localStorage.setItem('appVersion', latestVersion)
    } else if (storedVersion !== latestVersion) {
      yield put(triggerUpdateNotification(latestVersion))
    }
  } catch (error) {}
}

function* setCurrentFeatureRequest() {
  yield put(clearAutocompleteClients())
}

export function* watchForCheckForUpdates() {
  yield takeLatest(CHECK_FOR_UPDATES, checkForUpdatesSaga)
}

function* checkAppStatusSaga() {
  try {
    const { data } = yield call(getAppStatus)
    yield put(checkAppStatusSuccess(data))

    // Update maintenance info based on response
    // Backend returns status: "ok" or status: "maintenance"
    const isMaintenance = data?.status === 'maintenance'
    if (isMaintenance) {
      yield put(
        setMaintenanceInfo({
          active: true,
          startDate: data.startDate,
          endDate: data.endDate,
          reason: data.reason,
        }),
      )
    } else {
      // Only clear if there's no active maintenance already set (by 503 interceptor)
      const state = yield select()
      if (!state.common.maintenanceInfo?.active) {
        yield put(clearMaintenanceInfo())
      }
    }
  } catch (error) {
    yield put(checkAppStatusError(error))
  }
}

export function* watchForCheckAppStatus() {
  yield takeLatest(CHECK_APP_STATUS, checkAppStatusSaga)
}

function* finishMaintenanceSaga() {
  try {
    yield call(finishMaintenanceApi)
    yield put(finishMaintenanceSuccess())
    yield put(clearMaintenanceInfo())
  } catch (error) {
    yield put(finishMaintenanceError(error))
  }
}

export function* watchForFinishMaintenance() {
  yield takeLatest(FINISH_MAINTENANCE, finishMaintenanceSaga)
}

export function* getCurrencyTypesSaga() {
  yield takeLatest(GET_CURRENCY_TYPES, getCurrencyTypesRequest)
}

export function* getBanksSaga() {
  yield takeLatest(GET_BANKS, getBanksRequest)
}

export function* getBankReferencesSaga() {
  yield takeLatest(GET_BANK_REFERENCES, getBankReferencesRequest)
}

export function* setCurrentFeatureSaga() {
  yield takeLatest(SET_CURRENT_FEATURE, setCurrentFeatureRequest)
}

export default function* rootSaga() {
  yield all([
    fork(getCurrencyTypesSaga),
    fork(getBanksSaga),
    fork(getBankReferencesSaga),
    fork(watchForCheckForUpdates),
    fork(watchForCheckAppStatus),
    fork(watchForFinishMaintenance),
    fork(setCurrentFeatureSaga),
  ])
}
